import {
  MDBBtn,
  MDBIcon,
  MDBModalBody,
  MDBModalContent,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from "mdb-react-ui-kit";
import React from "react";

function SampeAIChecksPOPUP({ 
  aiResults, 
  setAiResults,
  onClose, 
  OnDone, 
  brandid 
}) {
  
  // Handler for toggle changes - directly updates aiResults
  const handleToggleChange = (attributeName) => {
    setAiResults(prev => ({
      ...prev,
      [attributeName]: !prev[attributeName]
    }));
  };

  return (
    <>
      <MDBModalContent>
        {/* Header */}
        <MDBModalHeader className="ai-review-header ">
          <div className="ai-header-content">
            <div className="ai-header-icon">
              <i className="fas fa-shield fa-lg text-primary"></i>
            </div>
            <div className="ai-header-text">
              <MDBModalTitle className="ai-modal-title">
                AI Review Summary
              </MDBModalTitle>
            </div>
          </div>
          <MDBBtn
            className="btn-close"
            color="none"
            onClick={(e) => {
              e.preventDefault();
              onClose();
            }}
          />
        </MDBModalHeader>

        {/* Body */}
        <MDBModalBody className="ai-review-body">
          <div className="ai-section-header">
            <span className="ai-section-label">Detected Attributes</span>
            <h6 className="ai-section-title">
              Based on your sample messages, AI has configured the attributes below. Please review and make any necessary adjustments before proceeding.
            </h6>
          </div>

          {/* Items */}
          <div className="ai-attributes-list">
            {/* 1. Embedded Link */}
            <div className="ai-attribute-card">
              <div className="ai-attribute-content">
                <div className="ai-attribute-icon">
                  <MDBIcon fas icon="link" />
                </div>
                <div className="ai-attribute-details">
                  <div className="ai-attribute-header ">
                    <div>
                    <span className="ai-attribute-name">Embedded Link</span>
                    <p className="ai-attribute-description">
                      {aiResults.embedded_link
                        ? "URLs or website links detected in your sample messages."
                        : "No URLs or website links detected in your sample messages."}
                    </p>
                    </div>
                  </div>
                </div>
                 <label className="switch">
                    <input
                      className="form-control"
                      type="checkbox"
                      checked={aiResults.embedded_link}
                      onChange={() => handleToggleChange('embedded_link')}
                    />
                    <span className="slider round"></span>
                  </label>
              </div>
            </div>

            {/* 2. Embedded Phone Number */}
            <div className="ai-attribute-card">
              <div className="ai-attribute-content">
                <div className="ai-attribute-icon">
                  <MDBIcon fas icon="phone" />
                </div>
                <div className="ai-attribute-details">
                  <div className="ai-attribute-header">
                    <div>
                    <span className="ai-attribute-name">
                      Embedded Phone Number
                    </span>
                    <p className="ai-attribute-description">
                      {aiResults.embedded_phnum
                        ? "A phone number detected in your sample messages."
                        : "No phone numbers detected in your sample messages."}
                    </p>
                    </div>
                  </div>
                </div>
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    checked={aiResults.embedded_phnum}
                    onChange={() => handleToggleChange('embedded_phnum')}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>

            {/* 3. Age-Gated Content */}
            <div className="ai-attribute-card">
              <div className="ai-attribute-content">
                <div className="ai-attribute-icon">
                  <MDBIcon fas icon="user-lock" />
                </div>
                <div className="ai-attribute-details">
                  <div className="ai-attribute-header">
                    <div>
                    <span className="ai-attribute-name">Age-Gated Content</span>
                    <p className="ai-attribute-description">
                      {aiResults.age_gated
                        ? "Age-restricted content detected in your sample messages."
                        : "No age-restricted content detected in your sample messages."}
                    </p>
                    </div>
                  </div>
                </div>
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    checked={aiResults.age_gated}
                    onChange={() => handleToggleChange('age_gated')}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </MDBModalBody>

        {/* Footer */}
        <MDBModalFooter className="ai-review-footer">
          <MDBBtn
            color="secondary"
            outline
            className="ai-btn-review"
            onClick={(e) => {
              e.preventDefault();
              onClose();
            }}
          >
            Back
          </MDBBtn>

          <MDBBtn
            color="primary"
            onClick={(e) => OnDone(e)}
            className="ai-btn-done"
          >
            {brandid ? "Proceed" : "Done"}
          </MDBBtn>
        </MDBModalFooter>
      </MDBModalContent>
    </>
  );
}

export default SampeAIChecksPOPUP;